import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";

import {populateDefaultItemData} from "../../../common/populate-default-item-data";

export const Updater = ({sku, apis, prepareSave, next}) => cs(
    consumeContext("templateOptionsCache"),
    ({templateOptionsCache}) => next({
        updateCcItem: async ({oldItem, additionalData = (_) => _}) => {
            const templateOptions = await templateOptionsCache.retrieve(sku);
            const {newValue, onSaved} = chain(
                oldItem,
                (_) => populateDefaultItemData(_, {templateOptions}),
                additionalData,
                prepareSave,
            );
            const ret = await apis.next.item.updateItem(newValue);
            await onSaved();
            return ret;
        },
        updateLegacyItem: async ({oldItem, additionalData = (_) => _}) => {

            const templateOptions = await templateOptionsCache.retrieve(sku);
            const newItem = additionalData(oldItem);
            const {newValue, onSaved} = prepareSave(newItem);
            const ret = await apis.next.item.updateItem(populateDefaultItemData(newValue, {templateOptions}));
            await onSaved();
            return ret;
        },
        createCcItem: async ({listingUniqueId, listSelected, listExternalId, additionalData = (_) => _}) => {

            const templateOptions = await templateOptionsCache.retrieve(sku);
            const {newValue, onSaved} = chain(
                null,
                (_) => populateDefaultItemData(_, {templateOptions}),
                (_) => changeNestedValue(_, ["listingUniqueId"], () => listingUniqueId),
                (_) => changeNestedValue(_, ["listSelected"], () => listSelected),
                (_) => changeNestedValue(_, ["listExternalId"], () => listExternalId),
                additionalData,
                prepareSave,
            );

            const ret = await apis.next.item.createItem(newValue);
            await onSaved();
            return ret;
        },
    })
);

